import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { lightGrey2Color } from 'js/config/style';

export default styled(Icon).attrs({
  name: 'refresh',
})`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.5rem;
  font-size: 1.2rem;
  cursor: pointer;
  color: ${lightGrey2Color};

  &:hover {
    color: ${lightGrey2Color.darken(1)};
  }
  &:active {
    color: ${lightGrey2Color.darken(2)};
  }
`;
